



























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { UpdateActivityGoods } from '@/api'
import { Message, MessageBox } from 'element-ui'
import { ElForm } from 'element-ui/types/form'

@Component({
  components: {},
})
export default class UpdateActivityGoodsDialog extends Vue {
  @Emit('close')
  private close() {
    this.show = false
    this.data = {}
  }
  private show = false
  private data: any = {}

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    activitySalesIntegral: [this.requiredRule],
    activityReturnIntegral: [this.requiredRule],
  }

  public open(data: any) {
    this.show = true
    this.data = data


    this.data.salesIntegral = this.data.salesIntegral / 100
    this.data.rewardIntegral = this.data.rewardIntegral / 100
    this.data.activitySalesIntegral = this.data.activitySalesIntegral / 100
    this.data.activityReturnIntegral = this.data.activityReturnIntegral / 100
  }

  public save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      const param = {
        id: this.data.activityGoodsId,
        activitySalesIntegral: this.data.activitySalesIntegral*100,
        activityReturnIntegral: this.data.activityReturnIntegral*100,
        sort: this.data.activitySort,
        inventory:this.data.activityInventory
      }
      await UpdateActivityGoods(param)
      Message.success('保存')
      this.close()
    })
  }
}
